import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3.85 21.03a2 2 0 0 0 .85.22c.309-.014.61-.1.88-.25l14.59-7.21a2 2 0 0 0 0-3.5L5.58 3a1.95 1.95 0 0 0-2.76 2.21L4.62 12l-1.8 6.79a2 2 0 0 0 1.03 2.24m.57-16.68a.53.53 0 0 1 .28-.1.46.46 0 0 1 .21.05l14.59 7.3a.43.43 0 0 1 .25.4.45.45 0 0 1-.25.41L4.91 19.72a.45.45 0 0 1-.64-.52l1.705-6.45h4.905a.75.75 0 0 0 0-1.5H5.97l-1.7-6.43a.44.44 0 0 1 .15-.47",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }